/*
 * Wishlist page table (sections/page-wishlist.liquid).
 *
 * Reads the product handles saved by the theme's wishlist hearts
 * (localStorage "m-wishlist-products", shared with assets/wishlist.js),
 * fetches each as /products/<handle>?view=wishlist-row and renders table
 * rows. Handles quantity steppers (keeps row total and the add-button's
 * data-quantity in sync), removal, and direct add-to-cart. Supplier-order
 * brackets render a [data-supplier-atc] button instead, which supplier-fee.js
 * picks up to show the tier chooser.
 */
(function () {
  var KEY = "m-wishlist-products";
  var body = document.querySelector("[data-wl-body]");
  if (!body) return;
  var wrap = document.querySelector("[data-wl-table-wrap]");
  var countEl = document.querySelector("[data-wl-count]");
  var noProducts = document.querySelector(".m-wishlist-no-products");

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function setList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }
  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }
  function updateCount(n) {
    if (countEl) countEl.textContent = "(" + n + (n === 1 ? " Item" : " Items") + ")";
  }
  function showEmpty() {
    if (wrap) wrap.hidden = true;
    if (noProducts) noProducts.classList.remove("m:hidden");
    updateCount(0);
  }

  function refreshDrawerAndOpen(res) {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, res || {});
      var drawer = document.querySelector("m-cart-drawer");
      if (drawer && typeof drawer.onCartDrawerUpdate === "function") {
        drawer.onCartDrawerUpdate();
        if (typeof drawer.open === "function") drawer.open();
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
      }
    }
  }

  var list = getList();
  if (!list.length) {
    showEmpty();
    return;
  }

  Promise.all(
    list.map(function (handle) {
      return fetch(
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/") + "products/" + handle + "?view=wishlist-row"
      )
        .then(function (r) {
          return r.ok ? r.text() : "";
        })
        .catch(function () {
          return "";
        });
    })
  ).then(function (htmls) {
    var tpl = document.createElement("template");
    tpl.innerHTML = htmls.join("");
    var rows = tpl.content.querySelectorAll("[data-wl-row]");
    if (!rows.length) {
      showEmpty();
      return;
    }
    body.appendChild(tpl.content);
    if (wrap) wrap.hidden = false;
    updateCount(body.querySelectorAll("[data-wl-row]").length);
  });

  function rowQtyInput(row) {
    return row.querySelector("[data-wl-qty-input]");
  }

  function syncRow(row) {
    var input = rowQtyInput(row);
    if (!input) return;
    var qty = Math.max(1, parseInt(input.value, 10) || 1);
    input.value = qty;
    var price = parseInt(row.dataset.price, 10) || 0;
    var totalEl = row.querySelector("[data-wl-total]");
    if (totalEl) totalEl.textContent = money(price * qty);
    var addBtn = row.querySelector("[data-wl-add], [data-supplier-atc]");
    if (addBtn) addBtn.dataset.quantity = qty;
  }

  body.addEventListener("change", function (e) {
    var row = e.target.closest("[data-wl-row]");
    if (row && e.target.closest("[data-wl-qty-input]")) syncRow(row);
  });

  body.addEventListener("click", function (e) {
    var row = e.target.closest("[data-wl-row]");
    if (!row) return;

    if (e.target.closest("[data-wl-minus]") || e.target.closest("[data-wl-plus]")) {
      var input = rowQtyInput(row);
      var qty = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = e.target.closest("[data-wl-plus]") ? qty + 1 : Math.max(1, qty - 1);
      syncRow(row);
      return;
    }

    if (e.target.closest("[data-wl-remove]")) {
      removeRow(row);
      return;
    }

    var addBtn = e.target.closest("[data-wl-add]");
    if (addBtn && !addBtn.classList.contains("is-loading")) {
      addBtn.classList.add("is-loading");
      var qty = Math.max(1, parseInt(addBtn.dataset.quantity, 10) || 1);
      fetch(
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/") + "cart/add.js",
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: [{ id: parseInt(addBtn.dataset.variantId, 10), quantity: qty }] }),
        }
      )
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) throw new Error(res.description || res.message || "add failed");
          refreshDrawerAndOpen(res);
          removeRow(row);
        })
        .catch(function (err) {
          console.error("[wishlist-table]", err);
        })
        .finally(function () {
          addBtn.classList.remove("is-loading");
        });
    }
  });

  function removeRow(row) {
    var handle = row.dataset.handle;
    setList(getList().filter(function (h) { return h !== handle; }));
    row.remove();
    var left = body.querySelectorAll("[data-wl-row]").length;
    if (left) updateCount(left);
    else showEmpty();
    var headerCounts = document.querySelectorAll(".m-wishlist-count");
    headerCounts.forEach(function (el) {
      el.textContent = left;
      if (!left) el.classList.add("m:hidden");
    });
  }

  /* Supplier-order brackets add through the tier chooser (supplier-fee.js);
     when that add succeeds, drop the matching row from the wishlist too. */
  document.addEventListener("supplier-fee:added", function (e) {
    var vid = e.detail && e.detail.variantId;
    if (!vid) return;
    var rows = body.querySelectorAll("[data-wl-row]");
    rows.forEach(function (row) {
      var btn = row.querySelector("[data-supplier-atc]");
      if (btn && parseInt(btn.dataset.variantId, 10) === vid) removeRow(row);
    });
  });
})();
